/** Тексты пространства «ability». Ключи именуются по смыслу, а не по месту. */
export const ability = {
  /* ── Разделы списка ─────────────────────────────────────────────────── */
  section: {
    published: 'Действуют сейчас',
    requests: 'Заявки и отказы',
    archived: 'Отозванные',
    expired: 'Срок вышел',
  },

  /* ── Пусто ──────────────────────────────────────────────────────────── */
  empty: {
    noTitle: 'Без названия',
    title: {
      published: 'Пока ничего не действует',
    },
    text: {
      published: 'Стартовые приходят из анкеты, остальное — заявкой квест-мастеру.',
      requests: 'Ничего не ждёт решения: всё либо принято, либо ещё не отправлено.',
      archived: 'Здесь пусто: ни одной способности пока не отзывали.',
    },
  },

  /* ── Действия ───────────────────────────────────────────────────────── */
  action: {
    create: 'Заявить',
    submit: 'Отправить заявку',
    editInForm: 'Править в анкете',
  },

  /* ── Что показываем после действия ──────────────────────────────────── */
  toast: {
    created: 'Заявка ушла квест-мастеру',
    archived: 'Способность убрана в архив',
  },

  /* ── Врезки над формой ──────────────────────────────────────────────── */
  note: {
    create: 'Заявка сразу уйдёт квест-мастеру. Пока он её не подтвердит, способность не действует.',
    edit: {
      rejected: 'Заявку завернули — в форме её текст. Поправьте и отправьте заново.',
      pending: 'Заявку ещё не рассмотрели — правка остаётся в той же строке.',
      approved:
        'Правка не трогает то, что действует сейчас: она уедет отдельной версией на проверку.',
    },
  },

  /* ── Стартовая способность: строки в таблице у неё нет ──────────────── */
  starting: {
    note: 'Действует, пока опубликована анкета.',
  },

  /* ── Состояние ──────────────────────────────────────────────────────── */
  state: {
    expired: 'срок вышел',
  },

  archived: {
    note: 'Вернуть из архива пока нельзя — попросите квест-мастера.',
  },

  /** Срок: у истёкшей и действующей разное время глагола. */
  expiry: {
    past: 'Действовала до {{date}}',
    future: 'Действует до {{date}}',
  },

  search: {
    placeholder: 'Название способности',
  },

  /** Винительный падеж: «Отправить способность в архив?» */
  subject: 'способность',

  /* ── Форма заявки ───────────────────────────────────────────────────── */
  form: {
    whatSection: 'Что заявляем',
    sourceSection: 'Откуда и надолго ли',
  },

  field: {
    description: 'Как работает',
    sourceLink: 'Ссылка на источник',
    sourcePlaceholder: 'vk.com/...',
    expiresAt: 'Действует до',
  },

  hint: {
    source: 'Квест, пост или отыгрыш — где это случилось. Так квест-мастеру быстрее',
    expiresAt: 'Пусто — бессрочно. Дата в прошлом не примется',
    image: 'Если способность выдали картинкой.',
  },

  error: {
    load: 'Не получилось загрузить список',
    titleRequired: 'Без названия заявку не отправить.',
  },
} as const;
